import React, { useCallback, useEffect, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { UserRole } from '@beable/roster-backend-client-v1';

interface RoleSelectorProps {
    onSelect: (role: UserRole) => void;
    className?: string;
    variant?: 'filled' | 'outlined';
    restrictTo?: UserRole[];
}

export default function RoleSelector({ variant, className, onSelect, restrictTo = [] }: RoleSelectorProps) {
    const [selectedRole, setSelectedRole] = useState<UserRole | undefined>(undefined);

    const handleRoleChange = async (event: any) => {
        if(!event.target.value) {
            return;
        }

        const role: UserRole = event.target.value;
        setSelectedRole(role);
        onSelect(role);
    };

    // When the list of restricted roles changes reset the selected role.
    useEffect(() => {
        setSelectedRole(undefined);
    }, [restrictTo]);

    const isMenuItemDisabled = useCallback((role: string) => {
        const disabledRoles = Object.keys(UserRole).filter(role => restrictTo.map(r => r.toString()).includes(role));
        return disabledRoles.length ? !disabledRoles.includes(role) : false;
    }, [restrictTo]);

    return <>
        <FormControl className={className} variant={ variant || 'standard' }>
            <InputLabel id="role-select-label">Select Role</InputLabel>
            <Select
                variant={ variant || 'standard' }
                id="select-role"
                data-cy="role-select"
                value={selectedRole ?? ''}
                onChange={handleRoleChange}>
                {Object.keys(UserRole).map((role) => (
                    <MenuItem
                      key={role}
                      value={role}
                      role='option'
                      disabled={isMenuItemDisabled(role)}
                    >
                        {role.charAt(0).toUpperCase() + role.slice(1)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    </>;
}
